import * as React from 'react';
import { useStoreActions } from 'easy-peasy';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Post } from '../../services/http';

export default function OurServicePage() {
    const [campaigns, setCampaigns] = React.useState(false);

    return (
        <main className="main main--null">
            <section className="services-list section">
                <div className="services-list__top">
                    <div className="container">
                        <div className="section__title section__title--reverse _anim-items  _fadeScale" data-animate-delay="02"><span>Our service</span></div>
                    </div>
                    <div className="services-list__path"></div>
                </div>
                <div className="container">
                    <div className="services-row  services-row--1 _anim-items _fadeUp" data-animate-delay="02">

                        <div className="services-row__img">
                            <img src="img/ser-list-1.png" alt="" />
                        </div>
                        <div className="services-row__content">
                            <div className="services-row__title"><span>Campaign building</span></div>
                            <div className="services-row__text">
                                <span className="selection-text">We will build a campaign that will help you get closer to your goal you are looking to raise.</span> <br />
                                <span className="font-600">We offer everything you need to build your campaign from A-Z.</span> This means you don’t need to worry about anything. We put together a campaign for you including articles, videos, photos, flyers, and more. <br /> We will set up your campaign on our platform and/or on The Chessed Fund platform if needed. We will then advertise your campaign via email and text blasts, and on many quality social media platforms.
                            </div>
                        </div>
                    </div>

                    <div className="services-row services-row--2 _anim-items _fadeUp" data-animate-delay="02">

                        <div className="services-row__img">
                            <img src="img/ser-list-2.png" alt="" />
                        </div>
                        <div className="services-row__content">
                            <div className="services-row__title"><span>Media marketing</span></div>
                            <div className="services-row__text">
                                <span className="selection-text">The only way to succeed with a campaign is to advertise it well and to do that in the right places.</span> <br />

                                We work with all email and text blasts, social media platforms, and other advertising options. <br />
                                We will follow the campaign progress and decide where to post and when accordingly. <br />
                                <span className="font-600">All marketing and advertising costs are not required upfront</span> The total will be deducted at the first attempt of cashing out.
                            </div>
                        </div>
                    </div>

                    <div className="services-row services-row--3 _anim-items _fadeUp" data-animate-delay="02">

                        <div className="services-row__img">
                            <img src="img/ser-list-3.png" alt="" />
                        </div>
                        <div className="services-row__content">
                            <div className="services-row__title"><span>Mailing service</span></div>
                            <div className="services-row__text">
                                <span className="selection-text">We create an eye-catching flyer presenting your cause.</span> <br />
                                With text, photos, and all the possible donation methods. <br />
                                We send out your campaign flyer to the thousands of addresses. <br />
                                <span className="font-600">This is a great way to reach out to donors who are not on social media,</span> or those who would like to see an actual flyer and send in a check.
                            </div>
                        </div>
                    </div>

                    <div className="services-row services-row--4 _anim-items _fadeUp" data-animate-delay="02">

                        <div className="services-row__img">
                            <img src="img/ser-list-4.png" alt="" />
                        </div>
                        <div className="services-row__content">
                            <div className="services-row__title"><span>Telemarketing</span></div>
                            <div className="services-row__text">

                                <span className="font-600">This is another powerful way to reach out</span> to those who are not necessarily on social media to see your campaign advertised. <br />
                                <span className="selection-text">We send out a pre-record message to thousands of phone numbers.</span> <br />Our system is constantly upgrading to add better features making it easier to make a donation using this method.
                            </div>
                        </div>
                    </div>

                    <div className="services-row services-row--5 _anim-items _fadeUp" data-animate-delay="02">

                        <div className="services-row__img">
                            <img src="img/ser-list-5.png" alt="" />
                        </div>
                        <div className="services-row__content">
                            <div className="services-row__title"><span>Signs and flyers</span></div>
                            <div className="services-row__text">
                                <span className="selection-text"></span>
                                <span className="selection-text">We create an eye-catching flyer that presents your cause in the best way possible. With text, photos, and all the possible donation methods.</span> <br />
                                This service is great for reaching out to those who won’t see your campaign online or on their phones. <span className="font-600">It also gives a certain validation to the campaign.</span> <br />
                                The signs get hung up in hundreds of Shuls in any city we feel your campaign can benefit from. The flyers are sent out by mail to thousands of addresses. Flyers can also be placed on tables in hundreds of Shuls.
                            </div>
                        </div>
                    </div>
                </div>

            </section>
            <section className="contacts">
                <div className="container">
                    <h1 className="contacts__title contacts__title--left _anim-items _fadeScale" data-animate-delay="01"><span>contact us</span></h1>
                </div>
                <div className="contacts__path">
                    <div className="container">
                        <div className="contacts-wrap">
                            <div className="contacts-wrap__item _anim-items _fadeRight" data-animate-delay="03">
                                <div className="contacts-wrap__icon">
                                    <img src="img/sprite/globus-lg.svg" alt="" />
                                </div>
                                <div className="contacts-wrap__text">
                                    <strong>Mail:</strong> <br />
                                    P.o. Box 1003,
                                    Lakewood NJ 08701
                                </div>
                            </div>
                            <div className="contacts-wrap__item _anim-items _fadeRight" data-animate-delay="04">
                                <div className="contacts-wrap__icon">
                                    <img src="img/sprite/marker.svg" alt="" />
                                </div>
                                <div className="contacts-wrap__text">
                                    <strong>Address:</strong> <br />
                                    16 Bridgewood Ave,
                                    Lakewood NJ 08701
                                </div>
                            </div>
                            <div className="contacts-wrap__item _anim-items _fadeRight" data-animate-delay="05">
                                <div className="contacts-wrap__icon">
                                    <img src="img/sprite/tel.svg" alt="" />
                                </div>
                                <div className="contacts-wrap__text">
                                    <strong>Call or Text: </strong> <br />

                                    732-307-8182 <br />
                                    <strong>WhatsApp:</strong> <br />
                                    Click here
                                </div>
                            </div>
                            <div className="contacts-wrap__item _anim-items _fadeRight" data-animate-delay="06">
                                <div className="contacts-wrap__icon">
                                    <img src="img/sprite/email.svg" alt="" />
                                </div>
                                <div className="contacts-wrap__text">
                                    <strong>Email:</strong> <br />

                                    <small>info@tomcheitzedaka.org</small>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </main>
    );
}
